
export const ASSIGN_PHYSICIAN = 'assign_physician'

export const CHECK_IMAGES = 'check_images'

export const CHECK_IMAGES_POST = 'check_images_post'

export const CHECK_IMAGES_AND_SCANS = 'check_images_and_scans'

export const CHECK_IMAGES_AND_SCANS_REFINEMENT = 'check_images_and_scans_refinement'

export const CLARIFY_PRE_TREATMENT = 'clarify_pre_treatment'

export const PRE_TREATMENT_CHECK = 'pretreatment_check'

export const CHECK_SCANS = 'check_scans'

export const CHECK_CUSTOMER_IMAGES = 'check_customer_images'

export const CREATE_TREATMENT_PLAN = 'create_treatment_plan'

export const CREATE_REFINEMENT_PLAN = 'create_refinement_plan'

export const CREATE_TREATMENT_PLAN_EXTERNAL = 'create_treatment_plan_external'

export const CREATE_REFINEMENT_PLAN_EXTERNAL = 'create_refinement_plan_external'

export const CREATE_TREATMENT_PLAN_EXTERNAL_PLANER = 'create_treatment_plan_external_planer'

export const CREATE_EXTERNAL_TREATMENT_PLAN_VISUALIZATION = 'create_external_treatment_plan_visualization'

export const CREATE_TREATMENT_QUOTATION = 'create_treatment_quotation'

export const CREATE_REFINEMENT_QUOTATION = 'create_refinement_quotation'

export const CHECK_IMPRINTS_VISUALLY = 'check_imprints_visually'

export const CONFIRM_TREATMENT_PLAN_DONE = 'confirm_treatment_plan_done'

export const CLARIFY_REMARKS = 'clarify_remarks'

export const DO_SEPA_PAYMENT = 'do_sepa_payment'

export const ENTER_PHYSICIAN_FEEDBACK = 'enter_physician_feedback'

export const REFUND = 'refund'

export const MANUALLY_CHECK_IMAGE_AVAILABILITY = 'manually_check_image_availability'

export const PROVIDE_TREATMENT_SETUP = 'provide_treatment_setup'

export const PROVIDE_REFINEMENT_SETUP = 'provide_refinement_setup'

export const REVIEW_TREATMENT_PLAN = 'review_treatment_plan'

export const REVIEW_REFINEMENT_PLAN = 'review_refinement_plan'

export const REVIEW_TREATMENT_PLAN_INTERNAL = 'review_treatment_plan_internal'

export const SCAN_IMPRINTS = 'scan_imprints'

export const SHIP_SET = 'ship_set'

export const UPLOAD_CASE = 'upload_case'

export const UPLOAD_TREATMENT_PLAN_FILES = 'upload_treatment_plan_files'

export const ORDER_ALIGNER = 'order_aligner'

export const VALIDATE_CANNOT_BE_TREATED = 'validate_cannot_be_treated'

export const TREATMENT_QUOTATION_CREATED_WHATS_APP = 'treatment_quotation_created_whatsapp'

export const TREATMENT_QUOTATION_FOLLOW_UP_CALL_1 = 'treatment_quotation_follow_up_call_1'

export const TREATMENT_QUOTATION_FOLLOW_UP_CALL_2 = 'treatment_quotation_follow_up_call_2'

export const SEND_TREATMENT_QUOTATION_REMINDER_WHATS_APP_1 = 'send_treatment_quotation_reminder_whatsapp_1'

export const SEND_TREATMENT_QUOTATION_REMINDER_WHATS_APP_2 = 'send_treatment_quotation_reminder_whatsapp_2'

export const BAD_IMPRINT_PATIENT_CALL = 'bad_imprint_patient_call'

export const COMPLEXITY_TREATMENT = 'treatment_plan_complexity_assignment'

export const MAKE_CUSTOMER_APPOINTMENT = 'make_customer_appointment'

export const MAKE_NEW_CUSTOMER_APPOINTMENT = 'make_new_customer_appointment'

export const PREPARE_TREATMENT_FILES = 'prepare_treatment_files'

export const VISUALIZATION_CHECK = 'visualization_check'

export const CHECK_TREATABILITY_AFTER_CLINIC = 'check_treatability_after_clinic'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/task-name.js